module.exports = __webpack_public_path__ + "img/logo.0adb1df5.png";